import { render, staticRenderFns } from "./BasketInfo.vue?vue&type=template&id=9e11bdf2"
import script from "./BasketInfo.vue?vue&type=script&lang=js"
export * from "./BasketInfo.vue?vue&type=script&lang=js"
import style0 from "./BasketInfo.vue?vue&type=style&index=0&id=9e11bdf2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports